import { NgModule } from '@angular/core';
import { SanitizeHtmlPipe } from './bypass-sanitize-html.pipe';


@NgModule({
	imports: [],
	exports: [SanitizeHtmlPipe,],
	declarations: [SanitizeHtmlPipe,],
	providers: [],
})
export class SanitizeHtmlPipeModule { }